import React, { ReactElement, useMemo, useState } from "react";
import { Alert } from "react-bootstrap";
import ReactDom from "react-dom";
import { RouteComponentProps } from "react-router";
import { ProjectService } from ".";
import { DataTable } from "../ui/DataTable";
import { Project } from "./Project";

interface IParams {
	id?: string;
}

export const ProjectsTable = (
	props: RouteComponentProps<IParams>,
): ReactElement => {
	const [projects, setProjects] = useState<Project[]>();
	const portal = document.getElementById("account-project-portal");
	let output;

	if (!portal) {
		throw Error("#account-project-portal element could not be found");
	}

	const projectService = new ProjectService();

	const columns = [
		{
			Header: "ID",
			accessor: "id",
		},
		{
			Header: "Name",
			accessor: "name",
			Cell: ({ row: { original } }: any) => (
				<a href={`/projects/${original.id}`}>{original.name}</a>
			),
		},
		{
			Header: "Status",
			accessor: "status",
		},
		{
			Header: "Budget",
			accessor: "budget",
			Cell: ({ cell: { value } }: any) => <>${value}</>,
		},
	];

	useMemo(() => {
		const fetchProject = async () => {
			const projectData = await projectService.findByAccount!(
				props.match.params.id || "",
			);
			setProjects(projectData);
		};

		fetchProject();
	}, []);

	if (!projects || !projects.length) {
		output = (
			<Alert variant="info">
				No projects have been added to this account.
			</Alert>
		);
	} else {
		output = <DataTable columns={columns} data={projects} />;
	}

	return ReactDom.createPortal(output, portal);
};
